import { render, staticRenderFns } from "./groupNews.vue?vue&type=template&id=010c5a28&scoped=true"
import script from "./groupNews.vue?vue&type=script&lang=js"
export * from "./groupNews.vue?vue&type=script&lang=js"
import style0 from "./groupNews.vue?vue&type=style&index=0&id=010c5a28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010c5a28",
  null
  
)

export default component.exports